/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    EventLogMetadataDto,
    EventLogMetadataDtoFromJSON,
    EventLogMetadataDtoFromJSONTyped,
    EventLogMetadataDtoToJSON,
} from './EventLogMetadataDto';

/**
 * 
 * @export
 * @interface CreateEventLogDto
 */
export interface CreateEventLogDto {
    /**
     * 
     * @type {EventLogMetadataDto}
     * @memberof CreateEventLogDto
     */
    metaData?: EventLogMetadataDto;
    /**
     * 
     * @type {string}
     * @memberof CreateEventLogDto
     */
    namespace: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEventLogDto
     */
    key: string;
}

export function CreateEventLogDtoFromJSON(json: any): CreateEventLogDto {
    return CreateEventLogDtoFromJSONTyped(json, false);
}

export function CreateEventLogDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateEventLogDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'metaData': !exists(json, 'metaData') ? undefined : EventLogMetadataDtoFromJSON(json['metaData']),
        'namespace': json['namespace'],
        'key': json['key'],
    };
}

export function CreateEventLogDtoToJSON(value?: CreateEventLogDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'metaData': EventLogMetadataDtoToJSON(value.metaData),
        'namespace': value.namespace,
        'key': value.key,
    };
}

